export const SET_REVISIONS = 'SET_REVISIONS'
export const RESET_REVISIONS = 'RESET_REVISIONS'
